import LTR from "@brand-icons/global/pin-store/pin-store-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinStoreIcon = iconFactory("PinStoreIcon", LTR);
